import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#050E1A] text-white pt-20 pb-10" data-testid="footer">
      <div className="container-apex">
        <div className="grid lg:grid-cols-12 gap-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-5">
            <Logo size={42} />
            <p className="mt-6 text-white/60 max-w-sm leading-relaxed">
              Your Complete Office Management Partner. Outsourced office administration, customer support, bookkeeping and document management for Canadian businesses.
            </p>
            <div className="mt-6 flex items-center gap-3 text-sm text-white/70">
              <MapPin size={14} className="text-[#16A34A]" /> Brampton, Ontario · Serving all of Canada
            </div>
            <div className="mt-2 flex items-center gap-3 text-sm text-white/70">
              <Mail size={14} className="text-[#16A34A]" /> info@adminapex.ca
            </div>
            <div className="mt-2 flex items-center gap-3 text-sm text-white/70">
              <Phone size={14} className="text-[#16A34A]" />
              <a href="tel:+16475107379" data-testid="footer-phone" className="hover:text-[#16A34A]">+1 (647) 510-7379</a>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-widest text-white/40 font-bold">Services</div>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li><a href="/#services" className="hover:text-[#16A34A]">Remote Admin</a></li>
              <li><a href="/#services" className="hover:text-[#16A34A]">Customer Support</a></li>
              <li><a href="/#services" className="hover:text-[#16A34A]">Bookkeeping</a></li>
              <li><a href="/#services" className="hover:text-[#16A34A]">Trucking Admin</a></li>
              <li><a href="/#services" className="hover:text-[#16A34A]">HR & Payroll</a></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-widest text-white/40 font-bold">Company</div>
            <ul className="mt-4 space-y-2 text-sm text-white/70">
              <li><a href="/#about" className="hover:text-[#16A34A]">About</a></li>
              <li><a href="/#process" className="hover:text-[#16A34A]">Process</a></li>
              <li><a href="/#faq" className="hover:text-[#16A34A]">FAQ</a></li>
              <li><Link to="/blog" className="hover:text-[#16A34A]">Blog</Link></li>
              <li><Link to="/company-profile" data-testid="footer-company-profile" className="hover:text-[#16A34A]">Company Profile (PDF)</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white/40 font-bold">Get Started</div>
            <p className="mt-4 text-sm text-white/70">Book a free 30-minute consultation and get a tailored support plan.</p>
            <Link to="/book" data-testid="footer-book-cta" className="btn-accent mt-5 inline-flex">Book Consultation</Link>
          </div>
        </div>
        <div className="pt-8 flex flex-wrap items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Admin Apex Business Solutions. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
            <span>www.adminapex.ca</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
